import { render, staticRenderFns } from "./DocumentosReferencias.vue?vue&type=template&id=dc1889be"
import script from "./DocumentosReferencias.vue?vue&type=script&lang=js"
export * from "./DocumentosReferencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports